// Shared by every registration form and teacher page that mentions the
// current event's name/year/dates, so none of them hardcode a value that
// goes stale every festival. Source of truth is EVENT_COLUMNS.eventName/
// startDate/endDate on the backend (Events tab) — public forms fetch it via
// GET /api/register/event, the teacher portal already has it as `event`
// from useTeacherData().

// Same 4-digit-year extraction Dashboard.js already does client-side for
// the "season" label.
export function eventYearFrom(startDate) {
  return startDate?.match(/\d{4}/)?.[0] || '';
}

function fmtMonthDay(date) {
  return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
}

// A bare "YYYY-MM-DD" string (exactly what event startDate/endDate are
// stored as, and what a <input type="date"> produces) gets parsed by
// `new Date(...)` as UTC midnight per the ECMAScript spec — converting that
// to any timezone behind UTC (all of North America) rolls the displayed
// date back by one day. Building the Date from its Y/M/D parts directly
// always constructs in local time, sidestepping that entirely. Anything
// else (already has a time component, or isn't a plain date) falls back to
// a normal Date parse.
export function parseLocalDate(dateStr) {
  if (!dateStr) return null;
  const match = String(dateStr).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (match) {
    const [, y, m, d] = match;
    return new Date(Number(y), Number(m) - 1, Number(d));
  }
  const d = new Date(dateStr);
  return isNaN(d) ? null : d;
}

// "May 27 – May 30, 2026" (same month) or "May 27 – June 2, 2026" (crosses
// a month boundary). Falls back to whichever single date parses if the
// other is missing/unparseable, and to '' if neither does — callers
// shouldn't hard-fail a registration form over date display text.
export function formatEventDateRange(startDate, endDate) {
  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);
  const startOk = !!start;
  const endOk = !!end;
  if (startOk && endOk) {
    return `${fmtMonthDay(start)} – ${fmtMonthDay(end)}, ${end.getFullYear()}`;
  }
  if (startOk) return start.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  if (endOk) return end.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
  return '';
}
